import { __extends } from "tslib";
import { fetchGroupAccessories } from '@gn-audio/core/api/product-catalogue';
import { GroupRestrictedSpotType } from 'src/Shared/enums/group-restricted-spot-type.enum';
import { ContactSupportSectionController } from 'src/Feature/ContactSupport/app';
var AccessoriesSpotController = (function (_super) {
    __extends(AccessoriesSpotController, _super);
    function AccessoriesSpotController($scope, $q, productContextService, dynamicPagesSpotsDisplayOptionsService) {
        var _this = _super.call(this, $scope, productContextService, dynamicPagesSpotsDisplayOptionsService, GroupRestrictedSpotType.Other) || this;
        _this.$scope = $scope;
        _this.$q = $q;
        _this.productContextService
            .subscribe()
            .then(null, null, function (group) {
            if (!group) {
                return;
            }
            _this.$scope.promise = _this.$q.when(fetchGroupAccessories(group.groupId))
                .then(function (accessories) {
                _this.$scope.accessories = accessories || [];
            });
        });
        _this.$scope.responsive = [
            { breakpoint: 576, settings: { slidesToShow: 1, slidesToScroll: 1 } },
            { breakpoint: 768, settings: { slidesToShow: 2, slidesToScroll: 2 } },
            { breakpoint: 992, settings: { slidesToShow: 3, slidesToScroll: 3 } },
        ];
        return _this;
    }
    AccessoriesSpotController.prototype.$onInit = function () {
        _super.prototype.$onInit.call(this);
    };
    AccessoriesSpotController.$inject = [
        '$scope',
        '$q',
        'productContextService',
        'dynamicPagesSpotsDisplayOptionsService',
    ];
    return AccessoriesSpotController;
}(ContactSupportSectionController));
export { AccessoriesSpotController };
